module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute pin-b pin-r pin-l w-full max-h-90 bg-brand overflow-scroll z-30\n            md:pin-none md:pin-t md:pin-l md:w-2/5 md:max-w-sm md:ml-4 md:mt-4 md:rounded md:shadow"
  }, [(_vm.currentState == 'consent') ? _c('ConsentStep', {
    key: "consent"
  }) : _vm._e(), _vm._v(" "), (_vm.currentState == 'addPoint') ? _c('AddPointStep', {
    key: "addPoint"
  }) : (_vm.currentState == 'waitingForPointConfirmation') ? _c('ConfirmPointStep', {
    key: "confirmPoint"
  }) : (_vm.currentState == 'imageUpload') ? _c('ImageUploadStep', {
    key: "imageUpload"
  }) : (_vm.currentState == 'pointSaved') ? _c('PointSavedStep', {
    key: "pointSaved"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7c5008e","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/views/AddPointView.vue
// module id = 173
// module chunks = 0